/**
 * 文件类型
 * @param All 所有的文件，不限制
 * @param Audio 音频文件
 * @param Video 视频文件
 */
enum MediaType {
    /**
     * 所有的文件，不限制
     */
    All,
    /**
     * 音频文件
     */
    Audio,
    /**
     * 视频文件
     */
    Video
}

export {
    MediaType
}